
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discuss/list",
      function () {
        return require("private-next-pages/discuss/list.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/discuss/list"])
      });
    }
  